import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from '../subheader-primary-nav/style.module.scss';

export const SubheaderLoginButtonsWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <div
      className={cx(styles['subheader-divider'], 'd-flex flex-column px-3 pb-4 pt-3')}
      style={{ gap: 16 }}
      slot="before"
    >
      {children}
    </div>
  );
};
